import get from 'lodash/get';

const getScaleDescription = question => {
  const scaleData = get(question, 'settings.meta.scaleDescription');

  if (scaleData) {
    const { minValue, maxValue } = scaleData;

    return {
      minValue,
      maxValue,
    };
  }

  return null;
};

export default getScaleDescription;



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getScaleDescription.js